import { render, staticRenderFns } from "./addCapability.vue?vue&type=template&id=936ac1b8&"
import script from "./addCapability.vue?vue&type=script&lang=js&"
export * from "./addCapability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('936ac1b8')) {
      api.createRecord('936ac1b8', component.options)
    } else {
      api.reload('936ac1b8', component.options)
    }
    module.hot.accept("./addCapability.vue?vue&type=template&id=936ac1b8&", function () {
      api.rerender('936ac1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/addCapability.vue"
export default component.exports